import * as React from "react";
import { Stack, Typography } from "@mui/material";
import { CustomeDialog } from "../../../shared";

export const FilePreviewComponent = ({ files }) => {
  const [openModal, setOpenModal] = React.useState(false);
  const [selectedImage, setSelectedImage] = React.useState(null);

  const handleFileClick = (fileUrl) => {
    const isPdf = fileUrl.toLowerCase().endsWith('.pdf');
    if (isPdf) {
      // Open PDF in new tab
      window.open(fileUrl, '_blank');
    } else {
      // Open image in modal
      setSelectedImage(fileUrl);
      setOpenModal(true);
    }
  };

  const handleDownloadImage = (imageUrl) => {
    // Extract filename from URL
    const fileName = imageUrl.split('/').pop();
    
    // Create a link element to download the file
    const link = document.createElement('a');
    link.href = imageUrl;
    link.download = fileName;
    link.target = '_blank'; // Helps with CORS issues in some browsers
    link.rel = 'noopener noreferrer';
    
    // Add to body, click, and remove
    document.body.appendChild(link);
    link.click();
    
    // Small delay before removing the element
    setTimeout(() => {
      document.body.removeChild(link);
    }, 100);
  };

  if (!files || files.length === 0) {
    return <span>No files</span>;
  }

  return (
    <>
      <Stack direction="row" flexWrap='wrap' gap="8px">
        {files.map((fileUrl, index) => {
          // Extract file name from URL
          const fileName = fileUrl.split('/').pop();
          // Determine if file is PDF or image
          const isPdf = fileUrl.toLowerCase().endsWith('.pdf');
          const fileIcon = isPdf ? "/icons/ic_pdf.svg" : "/icons/ic_image.svg";

          return (
            <Stack
              key={index}
              direction="row"
              spacing={1}
              alignItems="center"
              onClick={() => handleFileClick(fileUrl)}
              sx={{
                bgcolor: '#0000000F',
                borderRadius: '8px',
                padding: '4px 8px',
                cursor: 'pointer',
                '&:hover': { bgcolor: '#f5f5f5' }
              }}
            >
              <img src={fileIcon} alt="file" style={{ width: 16, height: 16 }} />
              <Typography
                variant="body2"
                sx={{
                  color: '#000000'
                }}
              >
                {fileName}
              </Typography>
            </Stack>
          );
        })}
      </Stack>

      {/* Image Modal */}
      <CustomeDialog
        open={openModal}
        content={
          <Stack sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Stack sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              backgroundColor: '#0000004D',
            }}>
              <Stack sx={{
                justifyContent: 'flex-end',
                flexDirection: 'row',
                gap: '12px',
                padding: '10px',
              }}>
                <img
                  className="modal-button"
                  src="/icons/ic_download.svg"
                  alt="download"
                  width={16}
                  height={16}
                  style={{ cursor: 'pointer' }}
                  onClick={() => selectedImage && handleDownloadImage(selectedImage)}
                />
                <img
                  onClick={() => setOpenModal(false)}
                  className="modal-button"
                  src="/icons/ic_close.svg"
                  alt="close"
                  width={16}
                  height={16}
                  style={{ cursor: 'pointer' }}
                />
              </Stack>
            </Stack>
            {selectedImage && (
              <img
                src={selectedImage}
                alt="Preview"
                style={{ maxWidth: '100%', maxHeight: '70vh' }}
              />
            )}
          </Stack>
        }
      />
    </>
  );
};